<template>
  <div class="relay-table">
    <table class="ui celled table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Field</th>
          <th>Logical/Port No</th>
          <th>Scene</th>
          <th>Function</th>
          <th>Status</th>
          <th>Override</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(relay, index) in relays">
          <tr :key="relay.id">
            <td>{{relay.id}}</td>
            <td>{{relay.field_name}}</td>
            <td>{{relay.logical_no}}</td>
            <td>{{relay.scene_name}}</td>
            <td>{{relay.function_name}}</td>
            <td style="text-align: center">
              <div v-if="relay.function_name != 'Momentary'">
                <el-tag type="danger" v-bind:class="{on: relay.status == 'on'}">{{relay.status}}</el-tag>
              </div>
              <div v-else>
                <el-tag type="gray">See Attached Site</el-tag>
              </div>
            </td>
            <td style="text-align: center">
              <div v-if="relay.function_name != 'Momentary'">
                <el-button class="manual-on" v-on:click="manual(relay.logical_no, 'on', index)" type="save">On</el-button>
                <el-button class="manual-off" v-on:click="manual(relay.logical_no, 'off', index)" type="cancel">Off</el-button>
              </div>
              <div v-else>
                <el-button class="manual-on toggle" v-on:click="manual(relay.logical_no, 'toggle', index)" type="save">Toggle</el-button>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import auth from '../../../auth'
  
  export default {
    name: 'relay-table',
    props:['id', 'rowData'],
    data () {
      return {
        relays:[],
      }
    },
    beforeMount(){
      var header = {headers: auth.getAuthHeader()};
      var profile = JSON.parse(auth.getProfile());
      var uri = auth.getApi();
      console.log(this.rowData.id);
      this.$http.get(uri + '/api/super/relays/devices/' + this.rowData.id, {headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
        this.relays = result.body.data;
      });
    },
    methods: {

      manual(logical, type, i){
        var header = {headers: auth.getAuthHeader()};
        var profile = JSON.parse(auth.getProfile());
        var uri = auth.getApi();

        var data = {
          url: `${this.rowData.ip}:${this.rowData.port}/api/host/modules/1/relays/logicals/`
        }
        this.$http.put(`${uri}/api/super/relay/${logical}/${type}`, data, {headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
          console.log(result);
          if(result && result.ok){
            this.relays[i].status = result.body.state;
          } else {
            this.$message({
              type:'error',
              message:result.body.msg,
              showClose: true,
            });
          }
        }).catch((err)=>{
          this.$message({
            type:'error',
            message:err.body.msg,
            showClose: true,
          });
        });
      }
    }
  }
  

</script>

<style>

  .relay-table .el-table .cell {
    text-align: center;
  }
  
  .on {
    background-color: rgba(18,206,102,.1);
    border-color: rgba(18,206,102,.2);
    color: #13ce66;
  }
  
  .relay-table .manual-on, .relay-table .manual-off {
    width: 30pt;
    padding: 5pt;
  }
  
  .toggle {
    width: 60pt !important;
  }
</style>




// WEBPACK FOOTER //
// RelayTable.vue?0fde47e4